import api from "api"
import { AuthData, UserTokenResponse } from "api/resources/auth/types"
import { USER_TYPE } from "utils/constants"

export const processAuthCode = async (
  code: string,
  platform = USER_TYPE,
  shadow = false
): Promise<AuthData | null> => {
  try {
    const response = await api.auth.getUserToken({
      data: {
        code,
        platform,
      },
    })

    return calculateTokenExpiration({
      ...response,
      // Keep the key off normal auth objects entirely
      ...(shadow && { shadow: true }),
    })
  } catch (e) {
    console.log(e)
    return null
  }
}

export const calculateTokenExpiration = (
  authInfo: UserTokenResponse & Pick<AuthData, "shadow">
): AuthData => {
  return {
    ...authInfo,
    generatedAt: Date.now(),
    expiresAt: Date.now() + authInfo.expiresIn * 1000,
  }
}
